import { Box, Button, Divider, TextInput } from "../../../../../../mads";
import { useI18n } from "../../../../../../shared/I18n";
import { useRnViewJobDisplay } from "../../../../context/ViewJobDisplayContext";

import { breakpoints } from "@indeed/ifl-tokens";
import React, { useState } from "react";
import { StyleSheet } from "react-native";

const RESPONSIVE_WRAPPER_CLASS = "rn-vj-standalone-desktop-search";
const responsiveStyles = `
  .${RESPONSIVE_WRAPPER_CLASS} {
    display: none;
  }

  @media (min-width: ${breakpoints.lg}) {
    .${RESPONSIVE_WRAPPER_CLASS} {
      display: block;
    }
  }
`;

export function StandaloneDesktopSearchBox() {
  const i18n = useI18n();
  const isDesktopStandalone = useRnViewJobDisplay() === "DESKTOP_STANDALONE";
  const [what, setWhat] = useState("");
  const [where, setWhere] = useState("");

  if (!isDesktopStandalone) {
    return null;
  }

  const submit = () => {
    const params = new URLSearchParams();
    const trimmedWhat = what.trim();
    const trimmedWhere = where.trim();
    if (trimmedWhat) {
      params.set("q", trimmedWhat);
    }
    if (trimmedWhere) {
      params.set("l", trimmedWhere);
    }
    const query = params.toString();
    window.location.assign(query ? `/jobs?${query}` : "/jobs");
  };

  const handleKeyDownCapture = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  };

  return (
    <>
      <style>{responsiveStyles}</style>
      <div className={RESPONSIVE_WRAPPER_CLASS}>
        <Box sx={styles.pageContainer}>
          <Box
            sx={styles.form}
            // @ts-expect-error - onKeyDownCapture is a DOM handler that mads BoxProps
            // doesn't declare, but react-native-web forwards unknown props to the
            // underlying <div>. The handler runs on web at runtime; this file is
            // .web.tsx so there's no native codepath to worry about.
            onKeyDownCapture={handleKeyDownCapture}
          >
            <Box sx={styles.field}>
              <TextInput
                testID="standalone-desktop-search-what"
                label={i18n.gettext("What")}
                placeholderText={i18n.gettext("Job title, keywords, or company")}
                value={what}
                onInput={setWhat}
                textAreaHeight={INPUT_HEIGHT}
              />
            </Box>
            <Box sx={styles.field}>
              <TextInput
                testID="standalone-desktop-search-where"
                label={i18n.gettext("Where")}
                placeholderText={i18n.gettext('City, state, zip code, or "remote"')}
                value={where}
                onInput={setWhere}
                textAreaHeight={INPUT_HEIGHT}
              />
            </Box>
            <Box sx={styles.buttonWrapper}>
              <Button
                testID="standalone-desktop-search-submit"
                onPress={submit}
                variant="primary"
                size="md"
              >
                {i18n.gettext("Find Jobs")}
              </Button>
            </Box>
          </Box>
          <Divider />
        </Box>
      </div>
    </>
  );
}

const INPUT_HEIGHT = 36;

const styles = StyleSheet.create({
  pageContainer: {
    paddingTop: 0,
    // @ts-expect-error - viewport units are web-only (react-native-web)
    width: "100vw",
    marginLeft: -216,
  },
  form: {
    alignSelf: "flex-start",
    flexDirection: "row",
    alignItems: "flex-end",
    gap: 12,
    minWidth: 600,
    maxWidth: 774,
    width: "100%",
    padding: 16,
    paddingTop: 0,
    marginLeft: 216,
  },
  field: {
    flex: 1,
  },
  buttonWrapper: {
    flexShrink: 0,
  },
});
